/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendUserDashboardResponseDto } from '../../models/backend-user-dashboard-response-dto';

export interface GetDashboardMeDashboardsDashboardIdGet$Params {
  dashboard_id: string;
}

export function getDashboardMeDashboardsDashboardIdGet(
  http: HttpClient,
  rootUrl: string,
  params: GetDashboardMeDashboardsDashboardIdGet$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendUserDashboardResponseDto>> {
  const rb = new RequestBuilder(rootUrl, getDashboardMeDashboardsDashboardIdGet.PATH, 'get');
  if (params) {
    rb.path('dashboard_id', params.dashboard_id, {});
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendUserDashboardResponseDto>;
    }),
  );
}

getDashboardMeDashboardsDashboardIdGet.PATH = '/me/dashboards/{dashboard_id}';
